export default {
  NEXT: 'I agree',
  ACCEPT_PRIVACY_POLICY: 'Accept privacy policy',
  VERIFY_LOGIN: {
    TITLE: `Create Your Password`,
    SUMMARY: ``
  },
  VALIDATE: {
    TITLE: `Verify Your Personal Information`,
    SUMMARY: ``
  },
  DO_NOT_FORGET: {
    TITLE: `Important Information`,
    SUMMARY: ``,
    THANK_YOU: `Thank you,`,
    IMPORTANT_INFOS: `Please save the following important information.`,
    USERNAMESECTION: `Your username:`,
    EMPLOYEENUMBERSECTION: `Your employee number:`,
    USERNAMEEMPLOYEENUMBERSECTION: 'Your username / employee number',
    PHONESECTION: `Merinio's phone number: `,
    COMPANYSECTION: `Web application:`,
    HELPCENTRESECTION: `Help center:`,
    WELCOME: `Welcome to Merinio! 🎉`,
    FINISH: `Enter`,
    ACKNOWLEDGE: `Got it!`,
    ACKNOWLEDGED: `OK`
  },
  VERIFY_CONTACT_INFO: {
    TITLE: `Verify your contact info`,
    SUMMARY: ``,
    DONE: `My contact information is up to date`
  },
  INVALID_TOKEN: `This token is invalid, expired, or has already been used.`,
  SAVE_PASSWORD_ERROR: `There was a problem resetting your password.`,
  ERROR: `Error`,
  SET_PASSWORD: `Choose a password`,
  PASSWORD: {
    PLACEHOLDER: `Enter your desired password`,
    LABEL: `Password`,
    DESCRIPTION: `Your password must be at least 8 and at most 64 characters long`
  },
  CONFIRMPASSWORD: {
    PLACEHOLDER: `Enter your desired password again`,
    LABEL: `Confirm password`,
    DESCRIPTION: ``
  },
  PASSWORDS_MUST_MATCH: `The passwords must match.`,
  PASSWORD_SAVE_ERROR: `An error occured while saving your password. Please contact your manager.`,
  ADDRESS: {
    PLACEHOLDER: `Enter your email address`,
    LABEL: `Email address`,
    DESCRIPTION: `This information is used to send you bulletins, schedule notifications, shift offers, and more.`
  },
  TYPE: {
    PLACEHOLDER: ``,
    LABEL: `Type`,
    DESCRIPTION: ``
  },
  MISSING_EMAIL: `First, please provide an email address.`,
  GO_TO_LOGIN: `Go to login`
}
